export default __webpack_public_path__ + "static/media/close.02224c75.svg";